// extracted by mini-css-extract-plugin
module.exports = {"button":"bjc-4W"};